module.exports = __webpack_public_path__ + "static/media/ProbabilityTree.2a7c31f2.jpg";